import { createContext } from "react";

export const TemplatesContext = createContext(null);
